import {
  SAMPLE_SEARCH,
  SAMPLE_FILTER_APPLY,
  SAMPLE_DATA_LOADING,
  SAMPLE_DATA_ERROR,
  SAMPLE_DATA_LOADED,
  SAMPLE_PRIMARY_TOGGLE
} from "../actions/Consts";

const initialState = {
  loading: false,
  errorMsg: "",
  books: { indexes:{years:[], states:[], subjects:[]}},
  filter: {years:[], states:[], subjects:[],value:{year:"",subject:"",state:""}},
  searchKey: "",
  renderingList: [],
  lastDisplayList : []
}
const SamplePageReducer = (state = initialState, { type, payload }) => {
  const loading = false;
  const errorMsg = "";
  switch (type) {
    case SAMPLE_DATA_LOADING:
      return { 
        ...state, 
        loading:true
      };
    case SAMPLE_DATA_ERROR:
      return { 
        ...state, 
        errorMsg: payload.errorMsg, 
        loading 
      }
    case SAMPLE_DATA_LOADED:
      return { 
        ...state, 
        renderingList: payload.renderingList, 
        lastDisplayList:payload.renderingList,
        books: payload.books, 
        filter: payload.filters,
        errorMsg, 
        loading 
      }
    case SAMPLE_PRIMARY_TOGGLE:
      return {
        ...state, 
        renderingList:payload.renderingList,
        lastDisplayList:payload.renderingList,
        searchKey:"",
        errorMsg, 
        loading
      }
      case SAMPLE_FILTER_APPLY:
        return { 
          ...state, 
          filter:payload.filter, 
          renderingList:payload.renderingList,
          lastDisplayList:payload.renderingList,
          searchKey:"", 
          errorMsg, 
          loading 
        }
    case SAMPLE_SEARCH:
      return { 
        ...state, 
        searchKey:payload.searchKey, 
        renderingList:payload.renderingList, 
        errorMsg, 
        loading 
      }
    default:
      return state
  }
}

export default SamplePageReducer